import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { IdentityLoginMethods } from 'altru-types';
import { getLoginMethods } from '@/store/identity/api';

@Module({ namespaced: true })
export default class IdentityVuexModule extends VuexModule {
  loginMethodsList: IdentityLoginMethods | undefined;

  get loginMethods(): IdentityLoginMethods | undefined {
    return this.loginMethodsList;
  }

  @Mutation
  setLoginMethods(value: IdentityLoginMethods): void {
    this.loginMethodsList = value;
  }

  @Action({ rawError: true })
  async fetchLoginMethods(email: string): Promise<IdentityLoginMethods | undefined> {
    try {
      const { data } = await getLoginMethods(email);
      this.context.commit('setLoginMethods', data);
      return data;
    } catch (e) {
      return e.response.data;
    }
  }
}
